export const skillCategories = [
  {
    category: "Frontend",
    skills: [
      { name: "React.js", icon: "react" },
      { name: "TypeScript", icon: "typescript" },
      { name: "JavaScript", icon: "javascript" },
      { name: "Next.js", icon: "nextjs" },
      { name: "Redux", icon: "redux" },
      { name: "HTML5", icon: "html5" },
      { name: "CSS3/SCSS", icon: "css3" },
      { name: "Tailwind CSS", icon: "tailwindcss" }
    ]
  },
  {
    category: "Backend",
    skills: [
      { name: "Node.js", icon: "nodejs" },
      { name: "Express.js", icon: "express" },
      { name: "MongoDB", icon: "mongodb" },
      { name: "SQL", icon: "sql" }
    ]
  },
  {
    category: "Testing & QA",
    skills: [
      { name: "Jest", icon: "jest" },
      { name: "React Testing Library", icon: "testing-library" }
    ]
  },
  {
    category: "DevOps & Tools",
    skills: [
      { name: "Docker", icon: "docker" },
      { name: "AWS", icon: "aws" },
      { name: "Webpack", icon: "webpack" },
      { name: "Git", icon: "git" }
    ]
  },
  {
    category: "AI Tools",
    skills: [
      { name: "ChatGPT", icon: "openai" },
      { name: "Claude.ai", icon: "anthropic" },
      { name: "Kiro", icon: "kiro" },
      { name: "Amazon Q", icon: "amazonq" },
      { name: "Grok API", icon: "grok" }

    ]
  }
];
